import React, { useCallback, useContext } from 'react';

import { colors } from 'theme/palette';
import {
  bootIntercomWidget,
  showIntercomWidget
} from 'utils/integrations/intercom';

import Button from 'components/Button';
import Dialog from 'components/Dialog';
import Typography from 'components/Typography';
import UserContext from 'components/UserContext';

import { ReactComponent as CalendarIcon } from './assets/calendar.svg';
import { ReactComponent as HelpIcon } from './assets/help.svg';
import { ReactComponent as MailIcon } from './assets/mail.svg';
import { ReactComponent as PhoneIcon } from './assets/phone.svg';
import { ReactComponent as TextBubbleIcon } from './assets/text-bubble.svg';
import styles from './styles.module.css';

const HelpDialog = ({ onClose }) => {
  const { user } = useContext(UserContext);

  const startChat = useCallback(() => {
    bootIntercomWidget({
      email: user.email,
      name: user.name
    });
    showIntercomWidget();

    onClose();
  }, [user, onClose]);

  return (
    <Dialog onClose={onClose} open classes={{ paper: styles.dialog }}>
      <div className={styles.container}>
        <HelpIcon className={styles.icon} />

        <Typography
          variant="H-TEXT-2"
          color={colors.pink2}
          className={styles.title}
        >
          We're here to help!
        </Typography>

        <div className={styles.resourceHubContainer}>
          <Typography variant="H-TEXT-3" color={colors.blue2}>
            Check out our
          </Typography>
          <Button
            variant="link"
            noTypography
            href="https://docs.google.com/document/d/1BXukj1oMbj7n5F5poETbv7_BzsaiUYGEKApbvkx9muQ/edit?usp=sharing"
            target="_blank"
          >
            <Typography variant="H-TEXT-3" color={colors.blue3}>
              Resource hub
            </Typography>
          </Button>
        </div>

        <div className={styles.infoWrapper}>
          <MailIcon />
          <div>
            <Typography variant="S-TEXT-1" color={colors.grey4}>
              Email us:
            </Typography>
            <Button variant="link" href="mailto:support@edlight.com">
              support@edlight.com
            </Button>
          </div>
        </div>

        <div className={styles.infoWrapper}>
          <PhoneIcon />
          <div>
            <Typography variant="S-TEXT-1" color={colors.grey4}>
              Give us a call:
            </Typography>
            <Button variant="link" href="tel:617-982-3242">
              617-982-3242
            </Button>
          </div>
        </div>

        {window.Intercom && (
          <div className={styles.infoWrapper}>
            <TextBubbleIcon />
            <div>
              <Button variant="link" onClick={startChat}>
                Start a Chat
              </Button>
            </div>
          </div>
        )}

        <div className={styles.infoWrapper}>
          <CalendarIcon />
          <div>
            <Button
              variant="link"
              href={`https://calendly.com/edlight/15min/?name=${user.name}&email=${user.email}`}
              target="_blank"
            >
              Schedule a 1:1 session
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default React.memo(HelpDialog);
